import { Signage } from '../Signage';
import CRC32 from 'crc-32';

/**
 * Return true if player uuid CRC32 hash is within selected range
 * @param {number} rangeStart - number from 0 to 100 representing beginning
 * percentage range of hash range
 * @param {number} rangeEnd - number from 0 to 100 representing ending of range
 * mapped to hash range
 * @return {boolean}
 */
function isSelectedForRollout(rangeStart, rangeEnd) {
    var result = false;
    if (Signage.playerUuid && rangeEnd > rangeStart) {
        var hash = CRC32.str(Signage.playerUuid);
        var max32BitInt = 2147483647;
        var number = hash + max32BitInt;
        var position = ((number / (max32BitInt * 2)) * 100).toFixed(2);
        result = rangeStart < position && position < rangeEnd;
    }
    return result;
}

export { isSelectedForRollout };
